module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_movies":"New Movies","more_movies":"View More"},"ja":{"new_movies":"新着動画","more_movies":"もっと見る"}}')
  delete Component.options._Ctor
}
